import { create } from 'zustand';

export interface B2CAuthUser {
  UserId?: string;
  FullName?: string;
  Email?: string;
  ProfileImage?: string;
  WalletBalance?: number;
}

export interface ApplyCreditResponse {
  UserId: string;
  DiscountId: number;
  Amount: number;
  HasUsedDiscount: boolean;
}

interface AuthStoreState {
  isLoggedIn: boolean;
  showAuthModal: boolean;
  showOTPModal: boolean;
  creditApplied: boolean;
  creditAmount: number;
  creditLoading: boolean;
  creditDetails: null | ApplyCreditResponse;
  setAuthModal: (show: boolean) => void;
  setOTPModal: (show: boolean) => void;
  login: () => void;
  logout: () => void;
  setCreditLoading: (loading: boolean) => void;
  setCreditAppliedDetails: (details: ApplyCreditResponse) => void;
  clearCreditDetails: () => void;
  removeCredit: () => void;
  // New additions for storing B2C User details, their own accesstoken, set their 
  b2CUser: null | B2CAuthUser;
  accessToken: string | null;
  setB2cAuth: (token: string, user: B2CAuthUser) => void;
  lastLoginMethod: string;
  setLastLoginMethod: (lastLoginMethod: string)=>void;
}

export const useAuthStore = create<AuthStoreState>((set) => ({
  isLoggedIn: false,
  showAuthModal: false,
  showOTPModal: false,
  creditApplied: false,
  creditAmount: 0,
  creditLoading: false,
  creditDetails: null,
  setAuthModal: (show: boolean) => set({ showAuthModal: show }),
  setOTPModal: (show: boolean) => set({ showOTPModal: show }),
  login: () => set({ isLoggedIn: true, showOTPModal: false, showAuthModal: false }),
  logout: () => set({ isLoggedIn: false, creditApplied: false, creditAmount: 0, creditDetails: null, b2CUser: null, accessToken: '' }),
  setCreditLoading: (loading: boolean) => set({ creditLoading: loading }),
  setCreditAppliedDetails: (details: ApplyCreditResponse) => set({ creditApplied: true, creditDetails: details, creditAmount: details.Amount }),
  clearCreditDetails: () => set({ creditApplied: false, creditDetails: null, creditAmount: 0 }),
  removeCredit: () => set({ creditApplied: false, creditDetails: null, creditAmount: 0 }),
  // Set last login value, wallet balance and logged in user details
  accessToken: '',
  b2CUser: null,
  setB2cAuth: (token: string, b2CUser: B2CAuthUser) => set({ accessToken: token, b2CUser }),
  lastLoginMethod: '',
  setLastLoginMethod: (lastLoginMethod: string)=> set({ lastLoginMethod })
}));
